module.exports = __webpack_public_path__ + "img/global.d50e996c.png";